import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AdTopBanner, AdBottomBanner } from '../components/AdSense';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Privacy Policy</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-6">Privacy Policy</h1>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6 space-y-6 text-gray-300">
            <p className="text-sm text-gray-500">Last Updated: January 2025</p>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Introduction</h2>
              <p className="leading-relaxed">
                PercentageCalculatorPlus.com respects your privacy and is committed to protecting your personal data. 
                This privacy policy explains how we collect, use, and safeguard your information when you visit our website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Information We Collect</h2>
              <p className="leading-relaxed mb-3">We may collect the following types of information:</p>
              <ul className="space-y-2 ml-4">
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>Usage Data:</strong> Information about how you use our website, including pages visited and time spent</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>Device Information:</strong> Browser type, operating system, and device type</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span><strong>Cookies:</strong> Small files stored on your device to improve your experience</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">How We Use Your Information</h2>
              <ul className="space-y-2 ml-4">
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span>To provide and maintain our calculator services</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span>To improve and optimize our website</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span>To analyze usage patterns and trends</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-cyan-400">•</span>
                  <span>To display relevant advertisements</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Cookies and Tracking</h2>
              <p className="leading-relaxed">
                We use cookies and similar tracking technologies to track activity on our website. You can instruct your 
                browser to refuse all cookies or indicate when a cookie is being sent. However, some features of our 
                website may not function properly without cookies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Third-Party Services</h2>
              <p className="leading-relaxed">
                We may use third-party services such as Google Analytics and Google AdSense. These services may collect 
                information about your use of our website. Please refer to their respective privacy policies for more information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Data Security</h2>
              <p className="leading-relaxed">
                We implement appropriate security measures to protect your information. However, no method of transmission 
                over the Internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Your Rights</h2>
              <p className="leading-relaxed">
                Depending on your location, you may have certain rights regarding your personal data, including the right 
                to access, correct, or delete your information. Contact us to exercise these rights.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-cyan-400 mb-3">Contact Us</h2>
              <p className="leading-relaxed">
                If you have questions about this Privacy Policy, please <Link to="/contact" className="text-cyan-400 hover:text-cyan-300">contact us</Link>.
              </p>
            </section>
          </div>

          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
